// lower case for backwards
export var ColumnTypeEnum;
(function (ColumnTypeEnum) {
    ColumnTypeEnum["number"] = "number";
    ColumnTypeEnum["date"] = "date";
    ColumnTypeEnum["string"] = "string";
    ColumnTypeEnum["boolean"] = "boolean";
    ColumnTypeEnum["decimal"] = "decimal";
    ColumnTypeEnum["period"] = "period";
    ColumnTypeEnum["picklist"] = "picklist";
})(ColumnTypeEnum || (ColumnTypeEnum = {}));
//# sourceMappingURL=columnType.js.map